import * as React from 'react'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import FieldSelector from 'modules/reports/components/Editor/Carcasa/FormFields/FieldSelector'
import type { FieldType } from 'modules/reports/components/Editor/Field/types'
import { ABILITIES, TYPES } from 'modules/reports/lib/Constants'
import type FilterForm from 'modules/reports/lib/Store/FormCollections/Filter/Form'
import type Field from 'modules/reports/store/models/Field'

interface Props {
  filterForm: FilterForm
  variables: unknown[]
  disabled: boolean
  onSelectFields: (fields: Field[]) => void
  onRemoveField: (field: FieldType) => void
  onReorderFields: (fields: FieldType[]) => void
}

const FilterGroup = ({
  filterForm,
  variables,
  disabled,
  onSelectFields,
  onRemoveField,
  onReorderFields,
}: Props) => {
  const label = {
    optional: true,
    text: i18n.t('custom_reports.fields.filter.title'),
    tooltipText: i18n.t('custom_reports.fields.filter.tooltip'),
  }

  return (
    <FieldSelector
      disabled={disabled}
      selectMultiple
      fieldTypes={filterForm.conditions ? filterForm.conditions.selectedFieldTypes : []}
      fieldAbilityTypes={ABILITIES.filtering ? [ABILITIES.filtering] : []}
      label={label}
      onSelectFields={onSelectFields}
      onRemoveField={onRemoveField}
      onReorderFields={onReorderFields}
      excludeIdentifiers
      excludeTypes={[TYPES.cohort, TYPES.link]}
      variables={variables}
      buttonLabel={i18n.t('custom_reports.fields.filter.button')}
      modalTitle={i18n.t('custom_reports.fields.filter_modal_title')}
      modalDescription={i18n.t('custom_reports.fields.filter_modal_description')}
      isFilter
    />
  )
}

export default observer(FilterGroup)
